import { render, staticRenderFns } from "./FindId_sns.vue?vue&type=template&id=0b8f8f2c"
import script from "./FindId_sns.vue?vue&type=script&lang=js"
export * from "./FindId_sns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports